var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgA = function SvgA(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.828 19.273h-2.33l5.234-14.546h2.536l5.234 14.546h-2.33L12.06 7.369h-.113l-4.12 11.904Zm.39-5.696h7.557v1.846H8.218v-1.846Z",
    fill: "#21272A"
  })));
};
export default SvgA;